export class VideoData {
  records: any[] = [];
  gridApi: any = null;
  loadingRecord: boolean = false;
  record: any = null;

}